import { EnvironmentProviders, Provider } from '@angular/core';

import { ApiConfiguration, CustomersMembersService, UsersProfileService } from '@customer-portal/api';

import { environment } from '../environments/environment';

export function provideApiService(): Array<Provider | EnvironmentProviders> {
  return [
    {
      provide: ApiConfiguration,
      useFactory: () => {
        const config = new ApiConfiguration();
        config.rootUrl = environment.api.baseUrl;
        return config;
      },
    },
    CustomersMembersService,
    UsersProfileService,
  ];
}
